import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import LastTransactionDetailsComponent from 'PointOfSale/modules/common/component/LastTransactionDetails';

class LastTransactionDetails extends Component {
  render() {
    const { lastTransactionProfile } = this.props;
    return (
      <LastTransactionDetailsComponent
        lastTransactionProfile={lastTransactionProfile}
      />
    );
  }
}

LastTransactionDetails.propTypes = {
  lastTransactionProfile: PropTypes.object
};

const mapStateToProps = state => ({
  lastTransactionProfile: state.PointOfSaleState.serving.lastTransactionProfile
});

const mapDispatchToProps = () => ({});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LastTransactionDetails)
);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/common/container/LastTransactionDetails.js